import React, { useEffect, useRef } from "react";

import { Field, FieldArray } from "formik";
import { IoTrash } from "react-icons/io5";

import {
  Flex,
  Box,
  HStack,
  Text,
  Divider,
  Spacer,
  Button,
  Icon,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import ErrorMessage from "../../../../components/CustomErrorMessage";

import { telefone as telMask } from "../../../../utils/masks";

const InformacoesContato = ({ formProps, scrollToField, border }) => {
  const anexoRef = useRef(null);

  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);

  return (
    <Flex
      flexDir="column"
      mt="15px"
      pl="15px"
      pr="30px"
      py="20px"
      bgColor="#FFF"
      borderRadius="8px"
      border={border ? border : ""}
      ref={anexoRef}
    >
      <Text
        color="#169499"
        fontWeight="700"
        fontSize="14px"
        lineHeight="19.6px"
      >
        {"Informações de contato".toUpperCase()}
      </Text>
      <Divider mt="14px" orientation="horizontal" />
      <Flex flexDir={{ base: "column", lg: "row" }} mt="20px">
        <FieldArray name="telefones">
          {(arrayHelpers) => (
            <Box w={{ base: "100%", lg: "45%" }}>
              {formProps.values.telefones &&
              formProps.values.telefones.length > 0 ? (
                formProps.values.telefones.map((telefone, index) => (
                  <Box key={`telefone-${index}`}>
                    <HStack
                      spacing="10px"
                      alignItems="center"
                      mt="8px"
                      w="100%"
                    >
                      <Field name={`telefones[${index}].telefone`}>
                        {({ field, form }) => (
                          <FormControl
                            id={`telefones[${index}].telefone`}
                            w="45%"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor={`telefones[${index}].telefone`}
                              d={index !== 0 ? "none" : "block"}
                            >
                              Telefone (s)
                            </FormLabel>
                            <Input
                              {...field}
                              maxLength={15}
                              h="42px"
                              name={`telefones[${index}].telefone`}
                              id={`telefones[${index}].telefone`}
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="(99) 99999-9999"
                              onChange={(e) => {
                                formProps.setFieldValue(
                                  `telefones[${index}].telefone`,
                                  telMask(e.target.value)
                                );
                              }}
                            />
                          </FormControl>
                        )}
                      </Field>
                      <Field name={`telefones[${index}].descricao`}>
                        {({ field, form }) => (
                          <FormControl
                            id={`telefones[${index}].descricao`}
                            w="45%"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor={`telefones[${index}].descricao`}
                              d={index !== 0 ? "none" : "block"}
                            >
                              Descrição
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name={`telefones[${index}].descricao`}
                              id={`telefones[${index}].descricao`}
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe a descrição"
                              maxLength={255}
                            />
                          </FormControl>
                        )}
                      </Field>
                      <Icon
                        d={index !== 0 ? "flex" : "none"}
                        id={`button-excluir-telefone${index}`}
                        aria-label="Excluir telefone"
                        color="#9EA1AE"
                        as={IoTrash}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => arrayHelpers.remove(index)}
                      />
                    </HStack>
                    <HStack
                      spacing="10px"
                      alignItems="center"
                      mt="8px"
                      w="100%"
                    >
                      <Text w="45%" color="#e53e3e" fontSize="14px">
                        <ErrorMessage name={`telefones[${index}].telefone`} />
                      </Text>
                      <Text w="45%" color="#e53e3e" fontSize="14px">
                        <ErrorMessage name={`telefones[${index}].descricao`} />
                      </Text>
                    </HStack>
                  </Box>
                ))
              ) : (
                <div />
              )}
              <Button
                id="button-adicionar-contato"
                mt="10px"
                w="max-content"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={500}
                fontSize="13px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  arrayHelpers.push({ telefone: "", descricao: "" });
                }}
              >
                Adicionar
              </Button>
            </Box>
          )}
        </FieldArray>
        <Spacer />
        <FieldArray name="emails">
          {(arrayHelpers) => (
            <Box w={{ base: "100%", lg: "45%" }}>
              {formProps.values.emails && formProps.values.emails.length > 0 ? (
                formProps.values.emails.map((email, index) => (
                  <Box key={`email-${index}`}>
                    <HStack spacing="10px" alignItems="center" mt="8px">
                      <Field name={`emails[${index}].email`}>
                        {({ field, form }) => (
                          <FormControl id={`emails[${index}].email`} w="45%">
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor={`emails[${index}].email`}
                              d={index !== 0 ? "none" : "block"}
                            >
                              E-mail (s)
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name={`emails[${index}].email`}
                              id={`emails[${index}].email`}
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="contato@email.com"
                              maxLength={255}
                              onChange={(e) => {
                                formProps.setFieldValue(
                                  `emails[${index}].email`,
                                  e.target.value.toLowerCase()
                                );
                              }}
                            />
                          </FormControl>
                        )}
                      </Field>
                      <Field name={`emails[${index}].descricao`}>
                        {({ field, form }) => (
                          <FormControl
                            id={`emails[${index}].descricao`}
                            w="45%"
                          >
                            <FormLabel
                              color="#5F6377"
                              fontWeight="500"
                              fontSize="14px"
                              lineHeight="19.6px"
                              htmlFor={`emails[${index}].descricao`}
                              d={index !== 0 ? "none" : "block"}
                            >
                              Descrição
                            </FormLabel>
                            <Input
                              {...field}
                              h="42px"
                              name={`emails[${index}].descricao`}
                              id={`emails[${index}].descricao`}
                              backgroundColor="#F9FAFB"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe a descrição"
                              maxLength={255}
                            />
                          </FormControl>
                        )}
                      </Field>
                      <Icon
                        d={index !== 0 ? "flex" : "none"}
                        id={`button-excluir-email${index}`}
                        aria-label="Excluir email"
                        color="#9EA1AE"
                        as={IoTrash}
                        boxSize="25px"
                        _hover={{ cursor: "pointer" }}
                        onClick={() => arrayHelpers.remove(index)}
                      />
                    </HStack>
                    <HStack
                      spacing="10px"
                      alignItems="center"
                      mt="8px"
                      w="100%"
                    >
                      <Text w="45%" color="#e53e3e" fontSize="14px">
                        <ErrorMessage name={`emails[${index}].email`} />
                      </Text>
                      <Text w="45%" color="#e53e3e" fontSize="14px">
                        <ErrorMessage name={`emails[${index}].descricao`} />
                      </Text>
                    </HStack>
                  </Box>
                ))
              ) : (
                <div />
              )}
              <Button
                id="button-adicionar-email"
                mt="10px"
                w="max-content"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={500}
                fontSize="13px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  arrayHelpers.push({ email: "", descricao: "" });
                }}
              >
                Adicionar
              </Button>
            </Box>
          )}
        </FieldArray>
      </Flex>
    </Flex>
  );
};

export default InformacoesContato;
